<template width="100">
  <div :class="classType">
    <header class="header">
      <span class="card-title">{{ title }}</span>
    </header>
    <div class="card-content">
      <div v-if="cardType === 'informes'">
        <Tarjeta v-for="informe in data" :autor="informe.author" :key="informe.id" :created-at="informe.createdAt"
          :report-type="informe.reportType" :card-type="cardType" :detail-id="informe.id">
        </Tarjeta>
      </div>
      <div v-if="cardType === 'consultas'">
        <TarjetaConsulta v-for="consulta in data" :key="consulta.id" :autor="consulta.autor.club.nombre"
          :club-id="consulta.autor.club.pk" :modified="consulta.modified" :departamento="consulta.departamento"
          :estado="consulta.estado" :detail-id="consulta.id" :logo="consulta.autor.club.logo" :card-type="cardType"
          :titulo="consulta.title" @goDetailConsultaPartido="detailConsultaPartido">
        </TarjetaConsulta>
      </div>
      <div v-if="cardType === 'adjuntos'">
        <TarjetaAdjunto v-for="adjunto in data" :id="adjunto.id" :key="adjunto.id" :name="adjunto.name"
          :itemUrl="adjunto.url" :description="adjunto.description" :author="adjunto.author" :authorClub="adjunto.club"
          :partido-id="partidoId">
        </TarjetaAdjunto>
      </div>
      <div v-if="cardType === 'comentarios' && this.$store.state.permissions.canViewComentarioPrePartido">
        <TarjetaComentario :partido-id="partidoId" :card-type="cardType"
          @goDetailComentarioPartido="detailComentarioPrePartido"
          @clickDetalle="$emit('goDetailComentarioPartido', arguments[0], arguments[1])"
          @createComentarioPrePartido="$emit('createComentarioPrePartido', arguments[0], arguments[1])"
          :localData="localData" :visitorData="visitorData">
        </TarjetaComentario>
      </div>
      <div class="no-content-container" v-if="data.length === 0 && cardType !== 'comentarios'">
        <v-icon color="676767" large>mdi-alert</v-icon>
        <span>No hay contenido para mostrar</span>
      </div>
      <v-btn v-if="cardType === 'consultas' && this.$store.state.permissions.canAddConsultas" app dark fab
        class="add-button create-consulta" @click="newConsultaPartido()">
        <v-icon>add</v-icon>
      </v-btn>
    </div>
    <footer class="tarjeta-footer" v-if="cardType === 'adjuntos'">
      <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
      <div v-if="saving">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
        <v-subheader class="right">Cargando, por favor espere.</v-subheader>
      </div>
      <div v-if="this.$store.state.permissions.canUploadAdjuntosFichaPartido" class="container-buttons">
        <v-btn icon @click="openFileDirectory" color="primary" :disabled="saving"><v-icon
            class="icono-paperclip">mdi-paperclip</v-icon></v-btn>
        <v-btn icon @click="uploadAllFiles" color="primary" :disabled="saving"><v-icon
            class="icono-trashcan">mdi-content-save</v-icon></v-btn>
      </div>
    </footer>
  </div>
</template>

<script>

import Tarjeta from '../components/Tarjeta.vue'
import TarjetaConsulta from './TarjetaConsulta.vue'
import TarjetaAdjunto from './TarjetaAdjunto.vue'
import AttachFile from '../../../common/ui/AttachFile.vue'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import TarjetaComentario from './TarjetaComentario.vue'

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations () {
    return {
      files: { required }
    }
  },
  data () {
    return {
      saving: false
    }
  },
  components: {
    Tarjeta,
    TarjetaConsulta,
    TarjetaAdjunto,
    AttachFile,
    TarjetaComentario
  },
  props: {
    classType: null,
    title: null,
    cardType: null,
    data: null,
    partidoId: null,
    localData: null,
    visitorData: null
  },
  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddConsultas
    }
  },
  methods: {
    newConsultaPartido () {
      this.$emit('createConsultaPartido')
    },
    detailConsultaPartido (consultaId) {
      this.$emit('ViewConsultaPartido', consultaId)
    },
    detailComentarioPrePartido (comentarioId, tabActiva) {
      this.$emit('ViewComentarioPrePartido', comentarioId, tabActiva)
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    submit () {
      this.$v.$touch()
      this.saving = true
      if (this.assets.length > 0) {
        this.axios
          .put('/partido/upload-s3/' + this.partidoId, { assets: this.assets })
          .then((responseS3) => {
            this.$refs.fileInput.cleanContent()
            this.saving = false
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      } else {
        this.clear()
        this.saving = false
      }
      this.$router.go()
    }
  },
  mounted () {
  }
}

</script>

<style scoped>
.card-container,
.card-consultas,
.card-adjuntos {
  background-color: #FCFBFB;
  max-width: 830px;
  min-height: 160px;
  margin: 30px auto 30px auto;
  padding: 0;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  -webkit-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  -moz-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.header {
  width: 100%;
  height: 55px;
  background-color: #293968;
  border-bottom: 8px solid #0bbad9;
  display: flex;
  justify-content: space-between;
  align-items: end;
}

.card-title {
  color: white;
  font-size: 2em;
  padding-left: 15px;
  font-weight: 400;
  background-color: #293968;
  z-index: 1;
}

.card-content {
  padding-bottom: 10px;
}

.create-consulta {
  position: absolute;
  right: 0;
  bottom: -40px;
}

.create-comentario {
  position: absolute;
  right: 0;
  bottom: -40px;
}

.card-consultas {
  position: relative;
}

.no-content-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: large;
  justify-content: center;
  align-content: center;
  color: "676767"
}

.tarjeta-footer {
  text-align: center;
}

.contenedor-clip-trash {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding-bottom: 10px;
}

.icono-paperclip,
.icono-trashcan {
  cursor: pointer;
}

.container-buttons {
  align-content: center;
  display: flex;
  justify-content: center;
}

.card-comentarios {
  background-color: #FCFBFB;
  max-width: 830px;
  min-height: 160px;
  margin: 30px auto 30px auto;
  padding: 0;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  -webkit-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  -moz-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.43);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0;
}
</style>
